import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  makeStyles,
  CardHeader,
  withStyles,
  InputBase,
  FormControl,
  NativeSelect,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import { palette, useStylesGlobal, msmSwalErrorRedirect } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import tableStyle from "configurations/styles/table";
import AddDetail from "../Buttons/AddDetail";
import Calculations from "./Calculations";
import bigDecimal from "js-big-decimal";
import InfoTaxesBtn from "../Vouchers/invoices/Buttons/InfoTaxesBtn";
import InfoAdditionalBtn from "../Vouchers/invoices/Buttons/InfoAdditionalBtn";
import DeleteProductDetail from "../Vouchers/invoices/Buttons/DeleteProductDatailBtn";
import EditDetail from "../Buttons/EditDetail";
import clientBackend from "configurations/axios";
import { useSelector, useDispatch } from "react-redux";
import { selectedResourceAction } from "redux/actions/resourcesActions";
import { getSub, getRUCEmpresa } from "redux/actions/userActions";
import PaymentMethods from "../Vouchers/invoices/Forms/PaymentMethods";
import AdditionalInfo from "../Vouchers/invoices/Forms/AdditionalInfo";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import ElectronicVoucherOptions from "../Vouchers/invoices/Forms/ElectronicVoucherOptions";
import AssignmentIcon from "@material-ui/icons/Assignment";
import TableDataSimple from "widgets/Tables/TableDataSimple";
import TableDataSimplePag from "widgets/Tables/TableDataSimplePag";
import checkInputs from "utils/checkInputs";
import { calculateDiscount } from "../Vouchers/invoices/validations";
import DiscountTotalInvoice from "../Vouchers/invoices/Forms/DiscountTotalInvoice";
import RetentionInvoice from "../Vouchers/invoices/Forms/RetentionInvoice";
import InformationDeferredPayment from "../Vouchers/invoices/Forms/InformationDeferredPayment";
import ComercialOrderInvoice from "./ComercialOrderInvoice";
import LogisticsInformationInvoice from "./LogisticsInformationInvoice";
import IdentificationDeliveryLocation from "./IdentificationDeliveryLocation";
import {
  entregaCafe,
  formatoCafe,
  envioContenedorReceptor,
  naturalezaOperacion,
  tiempoPago,
  tipoOperacion,
  tipoSucursal,
  tipoTransaccionVenta,
} from "./typeVoucher";
import AuthorizedRucs from "../Vouchers/invoices/Forms/AuthorizedRucs";
import ExportInvoice from "./ExportInvoice";
import MultipleReferenceDebitNote from "./MultipleReferenceDebitNote";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(0),
    textAlign: "center",
    color: theme.palette.text.primary,
    margin: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    boxShadow: "5px 3px 3px #aaaaaa",
    borderRadius: "8px",
    borderWidth: "2px",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "0%",
    textAlign: "justify",
  },
  divInput: {
    marginBottom: "0%",
    paddingRight: "0%",
    paddingLeft: "0%",
    textAlign: "justify",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  haedClient: {
    backgroundColor: palette.primary.main,
    width: "10%",
    display: "flex",
    flexWrap: "wrap",
    borderStyle: "solid",
    borderBottomWidth: "5px",
    borderRadius: "8px",
  },
  formClient: {
    padding: "10px",
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const InvoiceData = ({
  initialInvoiceDataGeneral,
  initialProductsDetalle,
  initialDetalles,
  inicialPagos,
  initialInformacionPagos,
  initialInformacionComercial,
  setIdAsgCliente,
  idAsgCliente,
  consumidorFinal,
  setFoundClient,
  setOptions,
  iDoc, //tipo de documento o comprobante
}) => {
  //para la fecha
  const dateToday = new Date();
  const maxDate = new Date();
  dateToday.setDate(dateToday.getDate() - 30);
  maxDate.setDate(dateToday.getDate() + 30);
  const dateTodayOut = format(
    new Date(),
    "yyyy-MM-dd'T'HH:mm:ss"
  );
  const tokenUser = useSelector((state) => state.user.tk);
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobales = useStylesGlobal();
  //para los cálculos
  const [totals, setTotals] = useState({
    subTotal_12: 0,
    subTotal_14: 0,
    subTotal_10: 0,
    subTotal_noIva: 0,
    totalDescuento: 0,
    subTotalSinImpuestos: 0,
    totalIsc: 0,
    totalIce: 0,
    totalPropina: 0,
    totalIva_10: 0,
    totalIva_12: 0,
    titalIva_14: 0,
    totalFactura: 0,
  });
  //para visualización del detalle
  const [viewDetalle, setViewDetalle] = useState(1);
  //Para la vista del cálculo
  const [viewCalculations, setViewCalculations] = useState(0);
  //State para la búsqueda
  const [productsDetalle, setProductsDetalle] = useState([]);
  //para la fecha del comprobante
  const [fechaEmision, setFechaEmision] = useState(new Date());

  const [destinoOperacion, setDestinoOperacion] = useState(1);

  const [numeracionSecuencial, setNumeracionSecuencial] = useState("");

  //para los datos que generan la transacción documentada(Datos generales de la factura)
  const [invoiceDataGeneral, setInvoiceDataGeneral] = useState({
    entregaCafe: "3",
    formatoCafe: "3",
    envioContenedorReceptor: "1",
    fechaContingencia: "", //es nulo porque el tipo de emision es normal
    tipoEmision: "01", //Es 01 por defecto porque es una Autorización de Uso Previa, operación normal
    motivoContingencia: "", //Es vacio porque es de autorizacion normal
    fechaSalida: "",
    informacionInteresEmisor: "",
    naturalezaOperacion: "01",
    tiempoPago: "1",
    tipoOperacion: "1",
    tipoSucursal: "",
    tipoTransaccionVenta: "",
    iDoc: iDoc.VALOR,
    
  });

  const getDiscount = (prodDetail) => {
    let discount = calculateDiscount(prodDetail);
    return discount.toFixed(2);
  };

  const columns = [
    {
      title: "Cantidad",
      //field: `cantidadProducto`,
      cellStyle: tableStyle.cellTable,
      width: "10%",
      filtering: false,
      editable: "never",
      render: (rowData) => <RoundNumber data={rowData.cantidadProducto} />,
    },
    {
      title: "Descripción",
      field: "descripcion",
      cellStyle: tableStyle.cellLeft,
      width: "30%",
      filtering: false,
      editable: "never",
    },
    {
      title: "Valor unitario",
      field: "precioUnitario",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      filtering: false,
      editable: "never",
      render: (rowData) => <RoundNumber data={rowData.precioUnitario} />,
    },
    {
      title: "Descuento",
      field: "descuentoProducto",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      filtering: false,
      editable: "never",
      render: getDiscount,
    },
    {
      title: "Total",
      field: "total",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      filtering: false,
      editable: "never",
      render: (rowData) => Number(rowData.total).toFixed(2),
    },
    {
      title: "OTIs",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      render: (rowData) => <InfoAdditionalBtn data={rowData} />,
      filtering: false,
      editable: "never",
    },
    {
      title: "Impuestos",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      render: (rowData) => <InfoTaxesBtn data={rowData} />,
      filtering: false,
      editable: "never",
    },
    {
      title: "Editar",
      field: "",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      render: (rowData) => (
        <EditDetail
          data={rowData}
          productsDetalle={productsDetalle}
          setProductsDetalle={setProductsDetalle}
          setViewDetalle={setViewDetalle}
          viewDetalle={viewDetalle}
          detalles={detalles}
          setDetalles={setDetalles}
        />
      ),
      filtering: false,
      editable: "never",
    },
    {
      title: "Eliminar",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      render: (rowData) => (
        <DeleteProductDetail
          productsDetalle={productsDetalle}
          setProductsDetalle={setProductsDetalle}
          data={rowData}
          setViewDetalle={setViewDetalle}
          viewDetalle={viewDetalle}
          detalles={detalles}
          setDetalles={setDetalles}
        />
      ),
      filtering: false,
      editable: "never",
    },
  ];

  const RoundNumber = (data) => {
    if (checkInputs.countDecimals(data.data) <= 2) {
      return parseFloat(data.data).toFixed(2);
    } else {
      return data.data;
    }
  };
  //para lo spagos
  const [pagos, setPagos] = useState([]);

  //para la información de los pagos
  const [informacionPagos, setInformacionPagos] = useState([]);

  //para los rucs autorizados
  const [rucsAutorizados, setRucsAutorizados] = useState([]);

  //para la informacion del pedido comercial de la factura
  const [informacionComercial, setInformacionComercial] = useState({});

  //para la informacion del local de entrega de la factura
  const [informationDeliveryPlace, setInformationDeliveryPlace] = useState({});

  //para la información de la informacion adicional de la factura
  const [additionalInfoInvoice, setAdditionalInfoInvoice] = useState([]);

  //para la información de las retenciones de la factura
  const [retentionInfoInvoice, setRetentionInfoInvoice] = useState([]);

  //para los descuentos adicionales de la factura
  const [additionalDiscountInvoice, setAdditionalDiscountInvoice] = useState(
    []
  );

  //para la informacion de logistica de la factura
  const [logisticInfoInvoice, setLogisticInfoInvoice] = useState({});

  //para la informacion extra en caso de que la factura sea de exportacion
  const [exportDataInvoice, setExportDataInvoice] = useState({});

  //para los documentos fiscales referenciados encaso de que sea una nota de debito referenciada a una o varias FE
  const [documentosFiscales, setDocumentosFiscales] = useState([]);

  //para los deatlles de la Factura
  const [detalles, setDetalles] = useState([]);

  //Objeto para crear la factura
  const [factura, setFactura] = useState({});

  //Objeto que tiene los errores entorno a los datos generales
  const [errorsInvoiceGeneral, setErrorsInvoiceGeneral] = useState({});

  //Objeto que tiene los errores entorno a los datos de exportación
  const [errorsExportDataInvoice, setErrorsExportDataInvoice] = useState({});

  //obtener el estado de la empresa
  const [company, setCompany] = useState(null);
  const dispatch = useDispatch();
  const selectedResource = (resource) =>
    dispatch(selectedResourceAction(resource));
  const handleClickHome = () => {
    selectedResource({
      id: "INI",
      nameMenu: "Inicio",
      titlePage: "Inicio",
      titleTab: "Inicio",
      menuPadre: null,
    });
  };

  useEffect(() => {
    const getCompany = async () => {
      await clientBackend
        .get("/cuenta/usuario/empresa/" + (tokenUser ? getRUCEmpresa(tokenUser) : "0"))
        .then((response) => {
          if (response.status >= 200 && response.status <= 300) {
            setCompany(response.data);
            if (!(response.data.estadoAfiliacionPac !== 3 && response.data.estadoCodigoSeguridadQr === 1)) {
              msmSwalErrorRedirect({
                titulo: "Error",
                mensaje: "La empresa no tiene permitido facturar, porque aún no se encuentra afiliada al PAC o no está generado el código de seguridad QR.",
                textButton: "Regresar inicio",
                callbackHandleResult: handleClickHome,
              });

            }
          }
        })
        .catch((excepcion) => {
          if (excepcion.response) {
            if (excepcion.response.status === 401) {
              //history.push("/");
            }
          } else {
          }
        });
    };
    getCompany();

    if (initialInvoiceDataGeneral){
      setInvoiceDataGeneral(initialInvoiceDataGeneral);
      initialInvoiceDataGeneral = null;
    }

    if (initialProductsDetalle){
      setProductsDetalle(initialProductsDetalle);
      initialProductsDetalle = null;
    }

    if(inicialPagos){
      setPagos(inicialPagos);
      inicialPagos = null;
    }

    if (initialInformacionPagos){
      setInformacionPagos(initialInformacionPagos);
      initialInformacionPagos = null;
    }

    if(initialInformacionComercial){
      setInformacionComercial(initialInformacionComercial);
      initialInformacionComercial = null;
    }

    if(initialDetalles){
      setDetalles(initialDetalles);
      addCalculs();
      initialDetalles = null;
    }


  }, []);

  const getNumeration = async () => {
    await clientBackend
      .get(
        `/asignacion/secuencial/usuario/secuencial/${tokenUser ? getSub(tokenUser) : null
        }/01`
      )
      .then((response) => {
        if (response.status === 200) {
          setNumeracionSecuencial(response.data);
          return response.data;
        }
      })
      .catch((exception) => {
        return exception;
      });
  };

  const addCalculs = () => {
    if (productsDetalle.length > 0) {
      let subTotIva_12 = new bigDecimal("0");
      productsDetalle.forEach((pr) => {
        if (pr.impuestoIva[0].CODIGO === "01") {
          let prTotal = new bigDecimal(pr.total);
          prTotal = prTotal.round(6, bigDecimal.RoundingModes.HALF_UP);
          let prIceTotal = new bigDecimal(pr.totalIceProducto);
          subTotIva_12 = subTotIva_12.add(prTotal).add(prIceTotal);
        }
      });

      let subTotIva_14 = productsDetalle.reduce(function (
        subTotIva_14,
        product
      ) {
        if (product.impuestoIva[0].CODIGO === "03") {
          return (
            Number(subTotIva_14) +
            Number(product.total) +
            Number(product.totalIceProducto)
          );
        } else {
          return subTotIva_14;
        }
      },
        0);

      let subTotIva_10 = productsDetalle.reduce(function (
        subTotIva_10,
        product
      ) {
        if (product.impuestoIva[0].CODIGO === "02") {
          return (
            Number(subTotIva_10) +
            Number(product.total) +
            Number(product.totalIceProducto)
          );
        } else {
          return subTotIva_10;
        }
      },
        0);

      let subTotNoIva = productsDetalle.reduce(function (subTotNoIva, product) {
        if (product.impuestoIva[0].CODIGO === "00") {
          return Number(subTotNoIva) + Number(product.total) + Number(product.totalIceProducto);
        } else {
          return subTotNoIva;
        }
      }, 0);

      let totDescuento = productsDetalle.reduce(function (
        totalDescuento,
        product
      ) {
        let valorDiscount = calculateDiscount(product);
        valorDiscount = bigDecimal.round(
          valorDiscount,
          6,
          bigDecimal.RoundingModes.HALF_UP
        );
        return totalDescuento + Number(valorDiscount);
      },
        0);

      let subTotSinImpuestos = new bigDecimal("0");

      productsDetalle.forEach((pr) => {
        let prTotal = new bigDecimal(pr.total);
        prTotal = prTotal.round(6, bigDecimal.RoundingModes.HALF_UP);
        subTotSinImpuestos = subTotSinImpuestos.add(prTotal);
      });

      let totOtis = new bigDecimal("0");
      let subTotOti = new bigDecimal("0");
      productsDetalle.forEach((pr) => {
        if (pr.informacionAdicional.length > 0) {
          let otisProduct = pr.informacionAdicional;
          otisProduct.forEach((oti) => {
            let prOti = new bigDecimal(oti.valor);
            subTotOti = subTotOti.add(prOti)
          })
          totOtis = totOtis.add(subTotOti);
        }
      });

      let totIsc = productsDetalle.reduce(function (totIsc, product) {
        if (product.tasaIsc != 0) {
          return totIsc + (product.total * product.tasaIsc);
        } else {
          return totIsc;
        }
      }, 0);

      let totIva_12 = bigDecimal.multiply(subTotIva_12.getValue(), "0.07");
      totIva_12 = bigDecimal.round(
        totIva_12,
        6,
        bigDecimal.RoundingModes.HALF_UP
      );
      let totIva_10 = bigDecimal.multiply(subTotIva_10.toString(), "0.10");
      totIva_10 = bigDecimal.round(
        totIva_10,
        6,
        bigDecimal.RoundingModes.HALF_UP
      );

      let totIva_14 = bigDecimal.multiply(subTotIva_14.toString(), "0.15");
      totIva_14 = bigDecimal.round(
        totIva_14,
        6,
        bigDecimal.RoundingModes.HALF_UP
      );

      let totSeguro = new bigDecimal("0");
      productsDetalle.forEach((pr) => {
        if (pr.seguro) {
          let prSeguro = new bigDecimal(pr.seguro.toString());
          prSeguro = prSeguro.round(6, bigDecimal.RoundingModes.HALF_UP);
          totSeguro = totSeguro.add(prSeguro);
        }
      });

      let totAcarreo = new bigDecimal("0");
      productsDetalle.forEach((pr) => {
        if (pr.acarreo) {
          let prAcarreo = new bigDecimal(pr.acarreo.toString());
          prAcarreo = prAcarreo.round(6, bigDecimal.RoundingModes.HALF_UP);
          totAcarreo = totAcarreo.add(prAcarreo);
        }
      });

      let totFactura =
        Number(subTotIva_12.getValue()) +
        Number(totIva_12) +
        Number(subTotIva_14) +
        Number(totIva_14) +
        Number(subTotIva_10) +
        Number(totIva_10) +
        Number(subTotNoIva) +
        Number(totIsc) +
        Number(totOtis.getValue()) +
        Number(totSeguro.getValue()) +
        Number(totAcarreo.getValue());

      //Calculos para sacar el total de la factura con descuentos adicionales a la factura
      let totalDiscount = new bigDecimal("0");
      additionalDiscountInvoice.forEach((pr) => {
        let prDiscount = new bigDecimal(pr.valor);
        prDiscount = prDiscount.round(6, bigDecimal.RoundingModes.HALF_UP);
        totalDiscount = totalDiscount.add(prDiscount);
      });
      let totVoucher = totFactura - Number(totalDiscount.getValue());

      let totItbms =
        Number(totIva_12) +
        Number(totIva_14) +
        Number(totIva_10);

      setTotals({
        //...totals,
        subTotal_12: bigDecimal.round(
          subTotIva_12.getValue(),
          6,
          bigDecimal.RoundingModes.HALF_UP
        ),
        subTotal_14: Number(
          bigDecimal.round(subTotIva_14, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        subTotal_10: Number(
          bigDecimal.round(subTotIva_10, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        subTotal_noIva: Number(
          bigDecimal.round(subTotNoIva, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalDescuento: Number(
          bigDecimal.round(totDescuento, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        subTotalSinImpuestos: Number(
          bigDecimal.round(
            subTotSinImpuestos.getValue(),
            6,
            bigDecimal.RoundingModes.HALF_UP
          )
        ),
        totalIce: Number(
          bigDecimal.round(totOtis.getValue(), 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalIva_12: Number(
          bigDecimal.round(totIva_12, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalIva_14: Number(
          bigDecimal.round(totIva_14, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalIva_10: Number(
          bigDecimal.round(totIva_10, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalPropina: Number(
          bigDecimal.round(
            totals.totalPropina,
            6,
            bigDecimal.RoundingModes.HALF_UP
          )
        ),
        totalFactura: Number(
          bigDecimal.round(totFactura, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalIsc: Number(
          bigDecimal.round(totIsc, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalItbms: Number(
          bigDecimal.round(totItbms, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalAcarreo: Number(
          bigDecimal.round(totAcarreo.getValue(), 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalSeguro: Number(
          bigDecimal.round(totSeguro.getValue(), 6, bigDecimal.RoundingModes.HALF_UP)
        ),
        totalFacturaConDescuento: Number(
          bigDecimal.round(totVoucher, 6, bigDecimal.RoundingModes.HALF_UP)
        ),
      });
    }
  };

  const clearAllData = () => {
    setTotals({
      subTotal_12: 0,
      subTotal_14: 0,
      subTotal_10: 0,
      subTotal_noIva: 0,
      totalDescuento: 0,
      subTotalSinImpuestos: 0,
      totalIce: 0,
      totalPropina: 0,
      totalIva_10: 0,
      totalIva_12: 0,
      titalIva_14: 0,
      totalFactura: 0,
      totalIsc: 0,
      totalItbms: 0,
      totalAcarreo: 0,
      totalSeguro: 0,
      totalFacturaConDescuento: 0,
    });

    setProductsDetalle([]);
    setDetalles([]);
    setPagos([]);
    setAdditionalInfoInvoice([]);
    setRetentionInfoInvoice([]);
    setNumeracionSecuencial("");
    setIdAsgCliente({});
    setFoundClient({});
    setOptions([]);
    setFechaEmision(new Date());
    setDestinoOperacion(1);
  };

  const handleChange = (event) => {
    setInvoiceDataGeneral({
      ...invoiceDataGeneral,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeCheck = (event) => {
    if (event.target.value === "1") {
      setDestinoOperacion(1);
    } else {
      setDestinoOperacion(2);
    }
  };
  const getDateOneMonthAgo = () => {
    let date = new Date();
    const month = date.getMonth();
    date.setMonth(date.getMonth() - 1);
  
    if (date.getMonth() === month) {
      date.setDate(0);
    }
  
    date.setHours(0, 0, 0);
    date.setMilliseconds(0);
    return date;
  };

  React.useEffect(() => {
    if (productsDetalle.length > 0) {
      addCalculs();

      setViewCalculations(1);
    } else {
      addCalculs();
      setViewCalculations(0);
    }
    if (numeracionSecuencial === "") {
      getNumeration();
    }
  }, [productsDetalle, viewDetalle, pagos, numeracionSecuencial, additionalDiscountInvoice]);

  const updateView = () => { };

  return (
    <Fragment>
      <div className={classesGlobales.rootDiv}>
        <Grid container xs={12} md={12} justify="center">
          <CardHeader
            className={classesGlobales.cabecera}
            title={"Datos Factura"}
            avatar={<AssignmentIcon></AssignmentIcon>}
          />
        </Grid>
        <Grid container spacing={1} className={classesGlobales.containerForm}>
        {iDoc.CODIGO === "NCR" ||iDoc.CODIGO === "NDR"||iDoc.CODIGO === "NCG"||iDoc.CODIGO === "NDG"  ? (
        <>
        <Grid item xs={12} md={2} className={classes.divForm}>
          <label>
            Destino de Operación: <font color={palette.error.main}>*</font>
          </label>
        </Grid>
        <Grid item xs={12} md={10}>
          <FormControl component="fieldset" className={classes.formControl}>
            <RadioGroup
              aria-label="destinoOperacion"
              name="destinoOperacion"
              className={classes.radio}
              
              required
              onChange={handleChangeCheck}
            >
              <FormControlLabel
                value="1"
                control={
                  <Radio color="primary" className={classes.radioButton} />
                }
                label="Panamá"
                labelPlacement="start"
                className={classes.radioLable}
              />
              <FormControlLabel
                value="2"
                control={
                  <Radio color="primary" className={classes.radioButton} />
                }
                label="Extranjero"
                labelPlacement="start"
                className={classes.radioLable}
              />
            </RadioGroup>
          </FormControl>
          </Grid>
        </>
      ) : null}
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Numeración: <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <input
              className={
                numeracionSecuencial
                  ? "form-control  is-valid"
                  : "form-control "
              }
              type="text"
              disabled
              placeholder="001-001-000000223"
              name="secuencial"
              value={numeracionSecuencial}
            />
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Fecha: <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
              <DatePicker
                className={
                  fechaEmision ? "form-control  is-valid" : "form-control "
                }
                disableToolbar
                autoOk
                disableFuture
                
                minDate={dateToday}
                variant="dialog"
                inputVariant="outlined"
                cancelLabel="Cancelar"
                okLabel="Seleccionar"
                format="yyyy-MM-dd'T'HH:mm:ssXXX"
                margin="normal"
                name="fechaEmision"
                value={fechaEmision}
                onChange={setFechaEmision}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Fecha de salida mercancía:</label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <input
              className={
                invoiceDataGeneral.fechaSalida
                  ? "form-control  is-valid"
                  : "form-control "
              }
              type="datetime-local"
              name="fechaSalida"
              format="yyyy-MM-dd'T'HH:mm:ssXXX"
              min={getDateOneMonthAgo()}
              value={invoiceDataGeneral.fechaSalida}
              onChange={handleChange}
              autoComplete="off"
              step="10"
            />
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Forma de entrega CAFE: <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.entregaCafe}
                name="entregaCafe"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {entregaCafe.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            {errorsInvoiceGeneral.entregaCafe ? (
              <p className={classesApp.errorLetters}>
                {errorsInvoiceGeneral.entregaCafe}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Formato de generación CAFE:{" "}
              <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.formatoCafe}
                name="formatoCafe"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {formatoCafe.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            {errorsInvoiceGeneral.formatoCafe ? (
              <p className={classesApp.errorLetters}>
                {errorsInvoiceGeneral.formatoCafe}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Envío del contenedor: <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.envioContenedorReceptor}
                name="envioContenedorReceptor"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {envioContenedorReceptor.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            {errorsInvoiceGeneral.envioContenedorReceptor ? (
              <p className={classesApp.errorLetters}>
                {errorsInvoiceGeneral.envioContenedorReceptor}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Información de interés:</label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <input
              className={
                invoiceDataGeneral.informacionInteresEmisor
                  ? "form-control  is-valid"
                  : "form-control "
              }
              type="text"
              placeholder="Ej. Información"
              name="informacionInteresEmisor"
              value={invoiceDataGeneral.informacionInteresEmisor}
              onChange={handleChange}
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Naturaleza de la operación:{" "}
              <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.naturalezaOperacion}
                name="naturalezaOperacion"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {naturalezaOperacion.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            {errorsInvoiceGeneral.naturalezaOperacion ? (
              <p className={classesApp.errorLetters}>
                {errorsInvoiceGeneral.naturalezaOperacion}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Tipo de la operación: <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.tipoOperacion}
                name="tipoOperacion"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {tipoOperacion.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            {errorsInvoiceGeneral.tipoOperacion ? (
              <p className={classesApp.errorLetters}>
                {errorsInvoiceGeneral.tipoOperacion}
              </p>
            ) : null}
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Tipo de la sucursal:</label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.tipoSucursal}
                name="tipoSucursal"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {tipoSucursal.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>Tipo de transacción venta:</label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.tipoTransaccionVenta}
                name="tipoTransaccionVenta"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {tipoTransaccionVenta.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} className={classes.divForm}>
            <label>
              Tiempo de pago: <font color={palette.error.main}>*</font>
            </label>
          </Grid>
          <Grid item xs={12} md={4} className={classes.divInput}>
            <FormControl className={classesGlobales.select}>
              <NativeSelect
                value={invoiceDataGeneral.tiempoPago}
                name="tiempoPago"
                onChange={handleChange}
                input={<BootstrapInput />}
              >
                <option aria-label="None" value="">
                  --Seleccione--
                </option>
                {tiempoPago.map((element) => (
                  <option key={element.CODIGO} value={element.CODIGO}>
                    {element.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
            {errorsInvoiceGeneral.tiempoPago ? (
              <p className={classesApp.errorLetters}>
                {errorsInvoiceGeneral.tiempoPago}
              </p>
            ) : null}
          </Grid>
        </Grid>
      </div>
      {iDoc.CODIGO === "FEX" || iDoc.CODIGO === "NCR" || iDoc.CODIGO === "FOE"?   (
        <ExportInvoice
          exportDataInvoice={exportDataInvoice}
          setExportDataInvoice={setExportDataInvoice}
          setErrorsExportDataInvoice={setErrorsExportDataInvoice}
          errorsExportDataInvoice={errorsExportDataInvoice}
        ></ExportInvoice>
      ) : null}

      {iDoc.CODIGO === "NDR" ||
        iDoc.CODIGO === "NCR" ||
        iDoc.CODIGO === "NDG" ||
        iDoc.CODIGO === "NCG" ? (
        <MultipleReferenceDebitNote
          documentosFiscales={documentosFiscales}
          setDocumentosFiscales={setDocumentosFiscales}
          iDoc={iDoc}
        ></MultipleReferenceDebitNote>
      ) : null}

      <div className={classesGlobales.rootDiv}>
        <Grid container xs={12} md={12}>
          <CardHeader
            className={classesGlobales.cabecera}
            title={"Detalles"}
            avatar={<AssignmentIcon></AssignmentIcon>}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <AddDetail
            productsDetalle={productsDetalle}
            setProductsDetalle={setProductsDetalle}
            viewDetalle={viewDetalle}
            setViewDetalle={setViewDetalle}
            detalles={detalles}
            setDetalles={setDetalles}
            errorsInvoiceGeneral={errorsInvoiceGeneral}
            setErrorsInvoiceGeneral={setErrorsInvoiceGeneral}
            invoiceDataGeneral={invoiceDataGeneral}
            exportDataInvoice={exportDataInvoice}
            setErrorsExportDataInvoice={setErrorsExportDataInvoice}
            errorsExportDataInvoice={errorsExportDataInvoice}
            iDoc={iDoc}
          />
          {productsDetalle.length > 0 ? (
            <Grid
              item
              xs={12}
              md={12}
              className={classesGlobales.containerForm}
            >
              {viewDetalle === 1 ? (
                <TableDataSimplePag
                  title=""
                  columns={columns}
                  data={productsDetalle}
                  buscar={false}
                ></TableDataSimplePag>
              ) : (
                <TableDataSimple
                  title=""
                  columns={columns}
                  data={productsDetalle}
                  buscar={false}
                ></TableDataSimple>
              )}
              <Grid container>
                <Grid xs={12} md={6}>
                  <DiscountTotalInvoice
                    additionalDiscountInvoice={additionalDiscountInvoice}
                    setAdditionalDiscountInvoice={setAdditionalDiscountInvoice}
                  ></DiscountTotalInvoice>
                </Grid>
                <Grid xs={12} md={6}>
                  <RetentionInvoice
                    retentionInfoInvoice={retentionInfoInvoice}
                    setRetentionInfoInvoice={setRetentionInfoInvoice}
                  ></RetentionInvoice>
                </Grid>
                {/* <Grid xs={12} md={12}>
                  <AdditionalInfo
                    additionalInfoInvoice={additionalInfoInvoice}
                    setAdditionalInfoInvoice={setAdditionalInfoInvoice}
                  ></AdditionalInfo>
              </Grid>*/}
              </Grid>
            </Grid>
          ) : null}
        </Grid>

        {viewCalculations === 1 ? (
          <Fragment>
            <Calculations
              totals={totals}
              setTotals={setTotals}
              discountVoucher={additionalDiscountInvoice}
              retentionVoucher={retentionInfoInvoice.length > 0
                ? retentionInfoInvoice[0].nombre
                : null} />
            <Grid container>
              <Grid xs={12} md={6}>
                <PaymentMethods
                  totals={totals}
                  pagos={pagos}
                  setPagos={setPagos}
                  productsDetalle={productsDetalle}
                  setProductsDetalle={setProductsDetalle}
                />
              </Grid>
              <Grid xs={12} md={6}>
                <InformationDeferredPayment
                  totals={totals}
                  informacionPagos={informacionPagos}
                  setInformacionPagos={setInformacionPagos}
                  productsDetalle={productsDetalle}
                  setProductsDetalle={setProductsDetalle}
                ></InformationDeferredPayment>
              </Grid>
              <Grid xs={12} md={12}>
                <ComercialOrderInvoice
                  informacionComercial={informacionComercial}
                  setInformacionComercial={setInformacionComercial}
                ></ComercialOrderInvoice>
              </Grid>
              <Grid xs={12} md={12}>
                <LogisticsInformationInvoice
                  logisticInfoInvoice={logisticInfoInvoice}
                  setLogisticInfoInvoice={setLogisticInfoInvoice}
                ></LogisticsInformationInvoice>
              </Grid>
              <Grid xs={12} md={12}>
                <IdentificationDeliveryLocation
                  informationDeliveryPlace={informationDeliveryPlace}
                  setInformationDeliveryPlace={setInformationDeliveryPlace}
                ></IdentificationDeliveryLocation>
              </Grid>
              <Grid xs={12} md={12}>
                <AuthorizedRucs
                  totals={totals}
                  rucsAutorizados={rucsAutorizados}
                  setRucsAutorizados={setRucsAutorizados}
                  productsDetalle={productsDetalle}
                ></AuthorizedRucs>
              </Grid>
            </Grid>
            <ElectronicVoucherOptions
              clearAllData={clearAllData}
              fechaEmision={fechaEmision}
              factura={factura}
              setFactura={setFactura}
              detalles={detalles}
              pagos={pagos}
              destinoOperacion={destinoOperacion}
              retentionInfoInvoice={retentionInfoInvoice}
              additionalInfoInvoice={additionalInfoInvoice}
              propina={totals.totalPropina}
              idCliente={idAsgCliente}
              consumidorFinal={consumidorFinal}
              totals={totals}
              additionalDiscountInvoice={additionalDiscountInvoice}
              logisticInfoInvoice={logisticInfoInvoice}
              informacionPagos={informacionPagos}
              informacionComercial={informacionComercial}
              rucsAutorizados={rucsAutorizados}
              invoiceDataGeneral={invoiceDataGeneral}
              exportInvoice={exportDataInvoice}
              documentsFiscalReference={documentosFiscales}
              informationDeliveryPlace={informationDeliveryPlace}
              company={company}
            //setTotals={setTotals}
            />
          </Fragment>
        ) : null}
      </div>
    </Fragment>
  );
};

export default InvoiceData;
